import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
}
const ChevronRight: React.FC<PropsT> = props => {
  const { className, fillColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M6 12L10 8L6 4"
        stroke={fillColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronRight
